// src/components/Navbar.js
import React, { useEffect, useState } from 'react'
import { Navbar, Nav, Container, Button, Image } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import reaLogo from '../assets/images/rea-logo.png'
import { scrollToSection } from '../utils/scrollToSection'
import AppButton from '../components/AppButton'

import '../pages/Navbar.css'

const NAV_LINKS = [
  { label: 'Home', targetId: 'homePage' },
  { label: 'Our Expertise', targetId: 'ourexperties', offset: 70 },
  { label: 'About us', targetId: 'aboutUs', offset: 120 },
  { label: 'Our Differentiators', targetId: 'ourDiffer', offset: 90 },
  { label: 'Transformative impact', targetId: 'transformativeImpact', offset: 90 },
  { label: 'FAQ', targetId: 'faq', offset: 90 },
  { label: 'Contact us', targetId: 'contactUs', offset: 90 },
];

const CustomNavbar = ({ isLoggedIn, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [expanded, setExpanded] = useState(false);
  const [isLoginPage, setIsLoginPage] = useState(false);

  useEffect(() => {
    setIsLoginPage(location.pathname === '/login');
  }, [location.pathname]);

  const handleLoginClick = () => {
    setExpanded(false);
  };

  const handleLogout = () => {
    onLogout();
    navigate('/');
    setExpanded(false);
  };

  return (
    <Navbar
      variant="light"
      fixed='top'
      expand="lg"
      className={`navbar navbar-framed ${isLoginPage ? 'login-bg' : ''}`}
      expanded={expanded}
    >
      <Container fluid className="navbarContainer">
        <Navbar.Brand href="#HeroSection" className="navBrandWrapper">
          <Image
            src={reaLogo}
            className="App-logo"
            alt="Resolution Experts Alliance Association"
          />
          <div className="navBrandText">
            <span className="navBrandTitle">Resolution</span>
            <span className="navBrandSubtitle">Experts Alliance Association</span>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle onClick={() => setExpanded(!expanded)} aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto navLinksList">
            {NAV_LINKS.map(({ label, targetId, offset }) => (
              <Nav.Link
                key={targetId}
                className='customNavLink me-2'
                href={`#${targetId}`}
                onClick={scrollToSection(targetId, offset)}
              >
                {label}
              </Nav.Link>
            ))}

            {isLoggedIn ? (
              <AppButton className='ms-3' onClick={handleLogout}>
                Logout
              </AppButton>
            ) : (
              <Button as={Link} to="/login" variant="primary" className='navLoginBtn' onClick={handleLoginClick}>
                Login
              </Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
